var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.182 16.252a.337.337 0 0 1-.236-.1.333.333 0 0 1-.091-.3l.471-2.357a.327.327 0 0 1 .091-.171l5.187-5.186a1 1 0 0 1 1.414 0l.943.943a1 1 0 0 1 0 1.414l-5.186 5.188a.332.332 0 0 1-.171.091l-2.357.471a.354.354 0 0 1-.065.007Zm.779-2.526-.353 1.768 1.768-.353 5.116-5.115a.334.334 0 0 0 0-.471l-.943-.943a.334.334 0 0 0-.472 0Zm1.579 1.726h.007Z",
    "data-name": "Path 17662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.585 14.252H1.917A1.669 1.669 0 0 1 .25 12.588V3.919a1.669 1.669 0 0 1 1.667-1.667H3.25a.333.333 0 1 1 0 .667H1.917a1 1 0 0 0-1 1v8.669a1 1 0 0 0 1 1h4.668a.333.333 0 1 1 0 .667Z",
    "data-name": "Path 17663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.251 8.251a.334.334 0 0 1-.333-.333v-4a1 1 0 0 0-1-1H8.584a.333.333 0 1 1 0-.667h1.334a1.668 1.668 0 0 1 1.667 1.667v4a.334.334 0 0 1-.334.333Z",
    "data-name": "Path 17664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.916 4.25h-4a1 1 0 0 1-1-1V1.918a.334.334 0 0 1 .333-.334h1.034a1.667 1.667 0 0 1 3.267 0h1.033a.334.334 0 0 1 .333.334V3.25a1 1 0 0 1-1 1Zm-4.333-2v1a.334.334 0 0 0 .333.335h4a.334.334 0 0 0 .334-.335v-1h-1a.334.334 0 0 1-.334-.332 1 1 0 1 0-2 0 .334.334 0 0 1-.333.332Z",
    "data-name": "Path 17665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.253 6.251H2.586a.333.333 0 1 1 0-.666h6.667a.333.333 0 1 1 0 .666Z",
    "data-name": "Path 17666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.253 8.254H2.586a.334.334 0 0 1 0-.668h6.667a.334.334 0 0 1 0 .668Z",
    "data-name": "Path 17667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.253 10.25H2.586a.333.333 0 1 1 0-.666h6.667a.333.333 0 1 1 0 .666Z",
    "data-name": "Path 17668"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.d735f5c0dca5e9093f6efc7522d77653.svg";
export { ForwardRef as ReactComponent };